<template>
    <div class="table-responsive">
        <table class="table table-hover no-overflow">
            <thead>
                <tr>
                    <th @click="$emit('sort', 'directDebitRequest.referenceNumber')">
                        Folio anexo D
                        <span v-if="directDebitStore.sortKey === 'directDebitRequest.referenceNumber'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'quotations.quotationsReferenceNumber')">
                        Folio cotización
                        <span v-if="directDebitStore.sortKey === 'quotations.quotationsReferenceNumber'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplication.referenceNumber')">
                        Folio solicitud
                        <span v-if="directDebitStore.sortKey === 'loanApplication.referenceNumber'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospectus.referenceNumber')">
                        Folio prospecto
                        <span v-if="directDebitStore.sortKey === 'prospectus.referenceNumber'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'product.referenceNumber')">
                        Folio producto
                        <span v-if="directDebitStore.sortKey === 'product.referenceNumber'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'name')">
                        Nombre
                        <span v-if="directDebitStore.sortKey === 'name'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospectus.personType.peopleTypeName')">
                        Tipo de persona
                        <span v-if="directDebitStore.sortKey === 'prospectus.personType.peopleTypeName'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'directDebitRequest.createdAt')">
                        Fecha creación
                        <span v-if="directDebitStore.sortKey === 'directDebitRequest.createdAt'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'directDebitRequest.updatedAt')">
                        Fecha actualización
                        <span v-if="directDebitStore.sortKey === 'directDebitRequest.updatedAt'">
                            <i :class="directDebitStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="directDebitRequestData.length > 0">
                    <tr v-for="directDebitRequest in directDebitRequestData"
                        :key="directDebitRequest.directDebitRequest.id">
                        <td>{{ directDebitRequest.directDebitRequest.referenceNumber }}</td>
                        <td>{{ directDebitRequest.quotations.quotationsReferenceNumber }}</td>
                        <td>{{ directDebitRequest.loanApplication.referenceNumber }}</td>
                        <td>{{ directDebitRequest.prospectus.referenceNumber }}</td>
                        <td>{{ directDebitRequest.product.referenceNumber }}</td>
                        <td>{{ getName(directDebitRequest) }}</td>
                        <td>{{ directDebitRequest.prospectus.personType.peopleTypeName }}</td>
                        <td>{{ $filters.formatDate(directDebitRequest.directDebitRequest.createdAt) }}</td>
                        <td>{{ $filters.formatDate(directDebitRequest.directDebitRequest.updatedAt) }}</td>
                        <td>
                            <PrimaryButton class="btn-success" @click="$emit('edit', directDebitRequest)"
                                data-toggle="modal" data-target="#directDebitModal">
                                <i class="fa fa-edit"></i>
                            </PrimaryButton>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="10" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { useDirectDebitStore } from '@/pinia/LoanApplications/Legal/useDirectDebitStore.module';
import { getCurrentInstance } from 'vue';

const props = defineProps({
    directDebitRequestData: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para editar un registro de anexo D
 * Acción por el boton de la tabla
 */
const emit = defineEmits(['sort', 'edit']);

const directDebitStore = useDirectDebitStore();

//Acceder a las propiedades globales
const instance = getCurrentInstance();
const $filters = instance?.appContext.config.globalProperties.$filters;

const getName = (item) => {
    if (item.prospectus.generalInfo.businessName === null) {
        return `${item.prospectus.generalInfo.firstName} ${item.prospectus.generalInfo.lastName} ${item.prospectus.generalInfo.mothersMaidenName}`;
    } else {
        return `${item.prospectus.generalInfo.businessName}`;
    }
}
</script>